import { Trash2 } from "lucide-react-native";
import React, { memo } from "react";

import { Box } from "@/components/atoms/Box";
import { Stack } from "@/components/atoms/Stack";
import { Text } from "@/components/atoms/Text";

/**
 * The drop-to-remove target the left rail turns into while a card is dragged
 * off the board.
 *
 * Extracted from `PlayerSidebarView` in SE-5490 so the add-players panel — the
 * pipeline surface's replacement for that rail — presents the IDENTICAL
 * removal affordance instead of silently losing drag-to-remove. One copy, two
 * rails; the `useDroppable` registration stays with each rail's container,
 * which is what owns the dnd-kit node.
 */
const SidebarRemovalZoneView = () => (
  <Stack className="h-full items-center justify-center">
    <Stack className="items-center gap-4">
      <Box className="size-20 items-center justify-center rounded-full bg-white/10">
        <Box className="text-content-primary">
          <Trash2 size={40} />
        </Box>
      </Box>
      <Stack className="items-center gap-2">
        <Text variant="title-lg" className="text-center text-content-primary">
          Remove from Board
        </Text>
        <Text variant="body" className="text-center text-content-muted">
          Drop player here to remove
        </Text>
      </Stack>
    </Stack>
  </Stack>
);

SidebarRemovalZoneView.displayName = "SidebarRemovalZoneView";

export default memo(SidebarRemovalZoneView);
